export var TradevestTransactionHistoryType;
(function (TradevestTransactionHistoryType) {
    TradevestTransactionHistoryType["TRADE"] = "TRADE";
    TradevestTransactionHistoryType["CASH"] = "CASH";
    TradevestTransactionHistoryType["CORPORATE_ACTION"] = "CORPORATE_ACTION";
})(TradevestTransactionHistoryType || (TradevestTransactionHistoryType = {}));
export var TradevestTransactionHistoryStatus;
(function (TradevestTransactionHistoryStatus) {
    TradevestTransactionHistoryStatus["MODIFIED"] = "MODIFIED";
    TradevestTransactionHistoryStatus["COMPLETED"] = "COMPLETED";
})(TradevestTransactionHistoryStatus || (TradevestTransactionHistoryStatus = {}));
export var TradevestTransactionDirection;
(function (TradevestTransactionDirection) {
    TradevestTransactionDirection["INCOMING"] = "INCOMING";
    TradevestTransactionDirection["OUTGOING"] = "OUTGOING";
})(TradevestTransactionDirection || (TradevestTransactionDirection = {}));
export var SecuritiesActivityKind;
(function (SecuritiesActivityKind) {
    SecuritiesActivityKind["TRADE_BUY"] = "TRADE_BUY";
    SecuritiesActivityKind["TRADE_SELL"] = "TRADE_SELL";
    SecuritiesActivityKind["DIGITAL_TRADE"] = "DIGITAL_TRADE";
    SecuritiesActivityKind["CASH"] = "CASH";
    SecuritiesActivityKind["TECHNICAL_CASH"] = "TECHNICAL_CASH";
    SecuritiesActivityKind["CORPORATE_ACTION_CASH"] = "CORPORATE_ACTION_CASH";
    SecuritiesActivityKind["CORPORATE_ACTION_POSITION"] = "CORPORATE_ACTION_POSITION";
})(SecuritiesActivityKind || (SecuritiesActivityKind = {}));
//# sourceMappingURL=tradevest-transactions.types.js.map